import anime from 'animejs';

const faqGrid = document.querySelector('.faq__grid');

const toggleQuestion = (e) => {
    if (e.target.dataset.id) {
        e.preventDefault();
        const id = e.target.dataset.id;
        const question = e.target;
        const answer = document.getElementById(id);
        const answerVisible = answer.getAttribute('aria-expanded') === 'true'; // converts data-attribute to boolean
        if (!answerVisible) {
            question.classList.add('open');
            anime({
                targets: answer,
                height: answer.scrollHeight,
                complete: () => {
                    answer.setAttribute('aria-expanded', 'true');
                }
            });
        } else {
            question.classList.remove('open');
            anime({
                targets: answer,
                height: 0,
                easing: 'linear',
                duration: 200,
                complete: () => {
                    answer.setAttribute('aria-expanded', 'false');
                }
            });
        }
    }
};

if (faqGrid) {
    faqGrid.addEventListener('click', (e) => toggleQuestion(e));
}
